export const translations = {
  app: {
    title: 'HashLab',
    subtitle: 'Hash Generátor és Ellenőrző',
  },
  nav: {
    home: 'Kezdőlap',
    textHash: 'Szöveg Hash',
    fileHash: 'Fájl Hash',
    verify: 'Ellenőrzés',
    batch: 'Batch Műveletek',
    api: 'API',
    settings: 'Beállítások',
  },
  common: {
    generate: 'Hash generálása',
    verify: 'Ellenőrzés',
    copy: 'Másolás',
    download: 'Letöltés',
    clear: 'Törlés',
    select: 'Kiválasztás',
    cancel: 'Mégse',
    save: 'Mentés',
    loading: 'Feldolgozás...',
    error: 'Hiba',
    success: 'Sikeres',
    noResults: 'Nincs eredmény',
  },
  input: {
    textPlaceholder: 'Írja be a szöveget...',
    filePlaceholder: 'Húzza ide a fájlt vagy kattintson a kiválasztáshoz',
    fileSelect: 'Fájl kiválasztása',
    multipleFiles: 'Több fájl kiválasztása',
  },
  algorithm: {
    label: 'Algoritmus',
    category: {
      cryptographic: 'Kriptográfiai hash-ek',
      sha3: 'SHA-3 család',
      blake: 'BLAKE család',
      checksum: 'Ellenőrzőösszeg',
      hmac: 'HMAC',
    },
  },
  encoding: {
    label: 'Kódolás',
    hex: 'Hexadecimális',
    hexUpper: 'Hexadecimális (nagybetűs)',
    base64: 'Base64',
    base32: 'Base32',
    base58: 'Base58',
    base62: 'Base62',
    base85: 'Base85',
    binary: 'Bináris',
  },
  options: {
    title: 'Beállítások',
    salt: 'Salt',
    key: 'Kulcs (HMAC)',
    iterations: 'Iterációk',
    outputCase: 'Kimenet esete',
    lower: 'Kisbetűs',
    upper: 'Nagybetűs',
  },
  result: {
    title: 'Eredmény',
    hash: 'Hash',
    algorithm: 'Algoritmus',
    encoding: 'Kódolás',
    duration: 'Időtartam',
    inputLength: 'Bemenet mérete',
    copied: 'Másolva!',
    downloadChecksum: 'Checksum fájl letöltése',
  },
  verification: {
    title: 'Hash ellenőrzés',
    expectedHash: 'Várható hash',
    computedHash: 'Számított hash',
    match: 'Egyezik',
    noMatch: 'Nem egyezik',
    enterHash: 'Adja meg a hash-t az ellenőrzéshez',
  },
  batch: {
    title: 'Batch műveletek',
    selectFiles: 'Fájlok kiválasztása',
    processing: 'Feldolgozás',
    completed: 'Befejezve',
    exportCSV: 'CSV export',
    exportChecksum: 'Checksum fájlok',
    progress: 'Előrehaladás',
  },
  settings: {
    title: 'Beállítások',
    theme: 'Téma',
    light: 'Világos',
    dark: 'Sötét',
    language: 'Nyelv',
    maxFileSize: 'Max fájlméret (MB)',
    defaultAlgorithm: 'Alapértelmezett algoritmus',
    defaultEncoding: 'Alapértelmezett kódolás',
  },
  errors: {
    fileTooLarge: 'A fájl túl nagy',
    invalidInput: 'Érvénytelen bemenet',
    algorithmNotSupported: 'Az algoritmus nem támogatott',
    hmacKeyRequired: 'HMAC-hez kulcs szükséges',
    fileReadError: 'Fájl olvasási hiba',
  },
  info: {
    clientSide: 'Minden hash kliensoldalon generálódik - az adatok nem kerülnek szerverre',
    passwordWarning: 'Figyelem: Egyszerű hash-ek (MD5, SHA-1) nem alkalmasak jelszavak tárolásához',
    largeFile: 'Nagy fájlok esetén a feldolgozás több időt vehet igénybe',
  },
};

